@if (isRequired) {
<div [class.accepted]="isAccepted" class="container">
    <mat-icon class="cookie-icon">cookie</mat-icon>
    <h2>
        <span i18n>Wykorzystujemy pliki </span>
        <q i18n>Cookies</q>
    </h2>
    <p>
        <span i18n>Strona korzysta z plików </span>
        <q i18n>Cookies</q>
        <span i18n> w celu realizacji usług. Możesz określić warunki zapisywania i obsługi plików </span>
        <q i18n>Cookies</q>
        <span i18n> w Twojej przeglądarce. Szczegóły znajdziesz w naszej </span>
        <a [routerLink]="privacyPolicyLink() | pathPipe" i18n>Polityce prywatności</a>.
    </p>
    <div class="actions">
        <button aria-label="Akceptuję" class="ui-button main" i18n-aria-label type="button" i18n
            (click)="accept()">Akceptuję</button>
    </div>
    <mat-icon (click)="accept()" class="close" aria-label="Zamknij" i18n-aria-label>close</mat-icon>
</div>
}
